import { FC, useCallback, useContext, useMemo } from 'react';
import { Box, Select } from '@robocorp/components';
import { useTranslation } from 'react-i18next';

import { useCurrentWorkspace, useWorkerGroupsQuery } from '~/queries';
import { VariablesContext } from '../context';

export const SelectEnvironmentGroup: FC = () => {
  const { endpoint, variables, setVariables } = useContext(VariablesContext);
  const { t } = useTranslation();

  const { data: currentWorkspace } = useCurrentWorkspace<'safeToParse'>();
  const { data: allWorkerGroups, isLoading: isLoadingWorkersGroups } = useWorkerGroupsQuery(
    currentWorkspace.id,
  );

  const environmentGroupItems = useMemo(
    () =>
      Object.entries(allWorkerGroups || []).map(([id, environmentGroup]) => {
        return {
          label: environmentGroup.name,
          value: id,
        };
      }),
    [allWorkerGroups],
  );

  const onChange = useCallback(
    (environmentGroupId: string) => {
      setVariables({
        environmentGroupId,
      });
    },
    [setVariables],
  );

  let placeholder = environmentGroupItems.length
    ? `${t('choose')}...`
    : t('workerApi.noWorkerGroups');

  if (isLoadingWorkersGroups) {
    placeholder = t('loading');
  }

  return !endpoint.includes('workerGroupId') ? null : (
    <Box mb={20}>
      <Select
        label={t('workerApi.chooseWorkerGroup')}
        items={environmentGroupItems}
        onChange={onChange}
        disabled={isLoadingWorkersGroups || environmentGroupItems.length < 1}
        value={variables.environmentGroupId}
        placeholder={placeholder}
      />
    </Box>
  );
};
